import { render, staticRenderFns } from "./widget_company_overview.vue?vue&type=template&id=efd0b8a8&"
import script from "./widget_company_overview.vue?vue&type=script&lang=js&"
export * from "./widget_company_overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports